import { User } from './user'

export class HCPPendingRequest {
    private id: String;
    private user: User;

    public constructor(id: String) {
        this.id = id;
    }

    public setId(id: String) { this.id = id; }
    public getId() { return this.id; }

    public setUser(user: User) { this.user = user; }
    public getUser() { return this.user; }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/hcppending-request.ts